import * as React from 'react';
import { StyleProvider } from '@ant-design/cssinjs';
import { cache } from './src/utils/antd-cache';
const STYLE_CONTAINER_ID = 'style-injection-container';
// Wrap the root element on the client-side for hydration
export const wrapRootElement = ({ element }) => {
  const container = document.getElementById(STYLE_CONTAINER_ID);
  return (<StyleProvider cache={cache} container={container}> {element} </StyleProvider>);
};